<template>
  <li class="nav-item" :class="hasChildren ? 'mob-dropdown-link mob-dropdown-center' : null">
    <div class="d-flex">
    <div class="d-flex justify-content-center">
      <router-link class="nav-link font-big"
          :to="mainNode.path"
                   :target="mainNode.target"
                   :class="hasChildrenLinksClass"
                   v-on="hasChildren ? { click: toggleChildren } : {}"
                    >{{ mainNode.name[this.store.state.general.locale] }}</router-link>
      <span class="mob-icon-span d-flex flex-column justify-content-center"
            v-if="hasChildren" @click="toggleChildren">
          <img :src="toggleChildrenArrow" alt=""/>
        </span>
    </div>
    </div>
    <div class="mob-dropdown-link mob-dropdown-link__container"
        :class="dropDownAnimation()"
         v-if="hasChildren"
         v-show="showChildren">
      <HeaderMenuChildMobComponent
          v-for="child in mainNode.children"
          :main-node="child"
          :key="child.id"
          :depth="depth + 1"
      />
    </div>
  </li>
</template>


<script>
import './headerMeniuChildMob.scss';
import angleDown from "/assets/images/angle-down.svg";
import angleUp from "/assets/images/angle-up.svg";
import {useStore} from "vuex";

export default {
  name: 'HeaderMenuChildMobComponent',
  props: {
    mainNode: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      showChildren: false,
      angleDown: angleDown,
      angleUp: angleUp,
    }
  },

  setup() {
    const store = useStore();

    return {
      store,
    };
  },

  methods: {

    toggleChildren() {
      this.showChildren = !this.showChildren;
    },
    dropDownAnimation() {
        return 'mob-dropdown-link__container__down-animation'
      }
  },

  computed: {
    hasChildrenLinksClass() {
      const state = this.hasChildren
      if (state) {
        return 'mob-menu-link-drop'
      } else {
        return 'mob-menu-link'
      }
    },

    hasChildren() {
      const { children } = this.mainNode
      return children && children.length > 0
    },
    //
    toggleChildrenArrow() {
      return this.showChildren ? this.angleUp : this.angleDown;
    },
  }
}

</script>